
<button type="button" id="{{config.id}}" class="manualSyncButton" [ngClass]="config.class"><i [ngClass]="config.iClass"></i></button>